/**
 * @author Ryan Hendrickson <rhendrickson@sitecrafting.com>
 * @description Fetches the necessary information for the path slider on the "My Account" page to be populated.
 */

(async () => {
    'use strict';

    // Grab the id for the div everything needs to be loaded after, if it doesn't exist, then bail.
    const userDashboard = document.querySelector('.profile-page');

    if (!userDashboard) {
        return;
    }

    // Assign necessary URL parameters and request the markup.
    const params = new URLSearchParams({
        action: 'fetch_pathway_slider_information',
    });

    fetch(`/wp-admin/admin-ajax.php?${params}`)
        .then((response) => {
            if (!response.ok) {
                throw new Error('Unable to fetch pathway slider information');
            }

            return response.json();
        })
        .then((json) => {
            document.querySelector('.achievement-banner').insertAdjacentHTML('afterend', json.markup);

            const nextButton = document.querySelector(".pathway-slider-next");
            const prevButton = document.querySelector(".pathway-slider-previous");
            const coursesWrapper = document.querySelector(".courses-wrapper");
            const courseSlides = document.querySelectorAll(".course-slide");

            /**
             * Updates the "NEXT" and "PREVIOUS" buttons as necessary.
             */
            const updateButtonVisibility = () => {
                const currentScrollPosition = coursesWrapper.scrollLeft;
                const maxScrollPosition = coursesWrapper.scrollWidth - coursesWrapper.clientWidth;

                // Show or hide the next button
                if (currentScrollPosition >= maxScrollPosition) {
                    nextButton.classList.add("hidden");
                } else {
                    nextButton.classList.remove("hidden");
                }

                // Show or hide the previous button
                if (currentScrollPosition <= 0) {
                    prevButton.classList.add("hidden");
                } else {
                    prevButton.classList.remove("hidden");
                }
            };

            /**
             * Handles scrolling between the individual slides.
             *
             * @param {string} direction Which way to scroll ("next" or "prev").
             */
            const scrollToSlide = (direction) => {
                const currentScrollPosition = coursesWrapper.scrollLeft;

                // Find the next or previous closest slide based on the direction
                let targetSlideIndex = 0;
                if (direction === "next") {
                    for (let i = 0; i < courseSlides.length; i++) {
                        if (courseSlides[i].offsetLeft > currentScrollPosition) {
                            targetSlideIndex = i;
                            break;
                        }
                    }
                } else if (direction === "prev") {
                    for (let i = courseSlides.length - 1; i >= 0; i--) {
                        if (courseSlides[i].offsetLeft < currentScrollPosition) {
                            targetSlideIndex = i;
                            break;
                        }
                    }
                }

                // Scroll to the target slide
                const targetSlide = courseSlides[targetSlideIndex];
                const scrollPosition = targetSlide.offsetLeft;

                coursesWrapper.scrollTo({
                    left: scrollPosition, behavior: "smooth",
                });
            };

            /**
             * Ensures we don't over/under scroll.
             *
             * @param {string} direction Which way to scroll ("next" or "prev").
             */
            const scrollByWrapperWidth = (direction) => {
                const scrollAmount = coursesWrapper.clientWidth; // Width of the container
                const currentScrollPosition = coursesWrapper.scrollLeft;

                // Calculate the new scroll position based on the direction
                const newScrollPosition = direction === "next" ? currentScrollPosition + scrollAmount : currentScrollPosition - scrollAmount;

                // Smoothly scroll to the new position
                coursesWrapper.scrollTo({
                    left: newScrollPosition, behavior: "smooth",
                });
            };

            /**
             * Handles the pathway slider scrolling.
             *
             * @param {string} direction Which way to scroll ("next" or "prev").
             */
            const handleScroll = (direction) => {
                // Check the window width and decide whether to scroll by wrapper width or to the next/previous slide
                if (window.innerWidth < 530) {
                    scrollByWrapperWidth(direction);
                } else {
                    scrollToSlide(direction);
                }
            };

            // Add click event listeners for the next and previous buttons
            nextButton.addEventListener("click", () => {
                handleScroll("next");
            });

            prevButton.addEventListener("click", () => {
                handleScroll("prev");
            });

            // Add scroll event listener to update button visibility
            coursesWrapper.addEventListener("scroll", updateButtonVisibility);

            // Initial button visibility check
            updateButtonVisibility();
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            // The page loads with a loader, this ensures it's removed whether the AJAX call succeeds or fails.
            document.querySelector('#pathway-slider-loader').remove();
        });
})();
